import React, { useEffect, useRef, useState } from 'react';
import './QuestionForm.css';

function QuestionForm({
  onSubmit,
  loading,
  requestsEnabled = false,
  initialQuestion = '',
}) {
  const [question, setQuestion] = useState(initialQuestion);
  const textareaRef = useRef(null);

  // Keep the box in step with a question that arrived via the URL (?q=).
  useEffect(() => {
    if (initialQuestion) {
      setQuestion(initialQuestion);
    }
  }, [initialQuestion]);

  const placeholderQuestions = [
    "Why should I care about spirituality?",
    "Is consciousness generated by the brain?",
    "How does Vedanta view suffering?",
    "Does Vedanta promote indifference to social problems?"
  ];

  // Autofocus on desktop only — on mobile it would pop the keyboard over the page.
  useEffect(() => {
    if (window.matchMedia('(min-width: 768px)').matches) {
      textareaRef.current?.focus();
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (question.trim()) {
      onSubmit(question);
      // Keep the question in the input field
    }
  };

  const handleKeyDown = (e) => {
    // Submit on Enter (but allow Shift+Enter for new lines)
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (question.trim()) {
        onSubmit(question);
      }
    }
  };

  const handlePlaceholderClick = (placeholderQuestion) => {
    setQuestion(placeholderQuestion);
    onSubmit(placeholderQuestion);
  };

  return (
    <form className="question-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="question" className="visually-hidden">
          Ask a question
        </label>
        <textarea
          id="question"
          ref={textareaRef}
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Ask anything about Vedanta…"
          rows="3"
          disabled={loading}
        />
        <div className="form-captions">
          <p className="ask-hint">
            {requestsEnabled
              ? "We'll look in the AskSwami Q&A first. If there's no match, you can request it."
              : "We'll look in the AskSwami Q&A for a matching answer."}
          </p>
          <p className="key-hint">Enter to submit · Shift+Enter for a new line</p>
        </div>
        <div className="placeholder-questions">
          <span className="placeholder-questions-label">Try one of these:</span>
          {placeholderQuestions.map((pq, index) => (
            <button
              key={index}
              type="button"
              className="placeholder-question"
              onClick={() => handlePlaceholderClick(pq)}
              disabled={loading}
            >
              {pq}
            </button>
          ))}
        </div>
      </div>
      <button type="submit" className="submit-button" disabled={loading || !question.trim()}>
        {loading ? 'Searching…' : 'Get Answers'}
      </button>
    </form>
  );
}

export default QuestionForm;
